import { useNetCashPayoutField } from '@makemydeal/dr-dash-components';

import { ReadOnlyValueRow } from '../../ReadOnlyValueRow';

export const NetCashPayoutRow = () => {
    const { label, inputProps } = useNetCashPayoutField();

    return (
        <ReadOnlyValueRow
            rowKey="netCashPayout"
            label={label}
            value={`$${inputProps.value}`}
            valueTestId={inputProps['data-testid']}
        />
    );
};
